// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"d9368507","239":"f152bee6","346":"084ca46d","351":"f55d1625","453":"95bd683f","500":"ab8ad0b9","732":"b50dc954","977":"50fab379","992":"aae1f914"}[chunkId] + ".chunk.js";
};